import App from "../application.js";

import "./setup_i18n";
import "jquery-validation/dist/localization/messages_cs.js";
import "../vendor/bootstrap-datepicker/locales/bootstrap-datepicker.cs.js";
import "moment/locale/cs.js";
import "./translations.tc.cs.js";

$.fn.datepicker.defaults.language = "cs";

I18n.defaultLocale = "cs";
I18n.locale = "cs";

export default App;
